import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

import "./main.css";
import {
  Search,
  ArrowLeft,
  ArrowRight,
  ArrowDropDown,
} from "@material-ui/icons";
import Reservation from "../Reservation/Reservation";
import Swal from "sweetalert2";
import { Context } from "../../context/Context";
import Agent from "../Agent/Agent";
const Main = ({ agentslist, historyP }) => {
  const { user, token } = useContext(Context);
  const [date, setDate] = useState(
    `${
      window.sessionStorage.getItem("data")
        ? window.sessionStorage.getItem("data")
        : new Date().toISOString().substr(0, 10)
    }`
  );
  const [reservations, setReservations] = useState([]);
  const [destinationCheck, setDestinationCheck] = useState(false);
  const sortedDate = useRef(false);
  const statusSorted = useRef(false);
  const [allReservation, setAllReservations] = useState([]);
  const [agents, setAgents] = useState([]);
  const searchReservations = useRef([]);
  const searchAllReservations = useRef([]);
  const [countReservations, setCountReservations] = useState();
  const [countReservationsArrived, setCountReservationsArrived] = useState();
  const yestarday = new Date(date).getTime() - 86400000;
  const tomarrow = new Date(date).getTime() + 86400000;
  let yestardayDate = new Date(yestarday).toISOString().substr(0, 10);
  let tomarrowDate = new Date(tomarrow).toISOString().substr(0, 10);
  const history = useHistory();

  useEffect(() => {
    const getCountGarages = async () => {
      try {
        const reservations = await axios.get(
          `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/admin/${date}`,
          {
            headers: { authorization: `megaparkingIGHERQHIGQRE ${token}` },
          }
        );
        let onlyArrived = reservations.data.filter((r) => r.hasArrived === true);
        setCountReservations(reservations.data.length);
        setCountReservationsArrived(onlyArrived.length);
      } catch (err) {
        console.log(err);
      }
    };
    getCountGarages();
  }, [date, token]);

  useEffect(() => {
    const getReservations = async () => {
      const role = user.role;
      if (role === "admin") {
        const res = await axios.get(
          `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/admin/${date}`,
          {
            headers: { authorization: `megaparkingIGHERQHIGQRE ${token}` },
          }
        );
        searchReservations.current = res.data;
        setReservations(res.data);
      } else if (role === "agent") {
        const res = await axios.post(
          `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/agent/${date}`,
          {
            agent: user.login,
          },
          {
            headers: { authorization: `megaparkingIGHERQHIGQRE ${token}` },
          }
        );
        searchReservations.current = res.data;
        setReservations(res.data);
      }
    };
    getReservations();
  }, [user?.agent, user?.role, user?.login, date, token]);

  const handleDataLeft = (e) => {
    setDate(yestardayDate);
    history.push(`/admin/${yestardayDate}`);
    window.sessionStorage.setItem("data", `${yestardayDate}`);
  };
  const handleDataRight = (e) => {
    setDate(tomarrowDate);
    history.push(`/admin/${tomarrowDate}`);
    window.sessionStorage.setItem("data", `${tomarrowDate}`);
  };

  const handleChangeReservations = (e) => {
    if (historyP) {
      let sortedReservations = searchAllReservations.current;
      sortedReservations = sortedReservations.filter((item) =>
        item.surname.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setAllReservations(sortedReservations);
    } else {
      let sortedReservations = searchReservations.current;
      sortedReservations = sortedReservations.filter((item) =>
        item.surname.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setReservations(sortedReservations);
    }
  };

  const sortByDate = async (e) => {
    if (!sortedDate.current) {
      const { value: data } = await Swal.fire({
        title: "Sortuj po:",
        input: "select",
        inputOptions: {
          arrive: "Data przyjazdu",
          leave: "Data odjazdu",
        },
        inputPlaceholder: "Wybierz datę",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        confirmButtonColor: "#1267a2",
      });

      if (data === "arrive") {
        const dayReservations = reservations.filter(
          (r) => r.arriveData === date
        );
        for (let i = 0; i < dayReservations.length; i++) {
          const hourArrive =
            dayReservations[i].arriveHour.length === 4
              ? `0${dayReservations[i].arriveHour}`
              : dayReservations[i].arriveHour;
          dayReservations[i].miliseconds = new Date(
            `${dayReservations[i].arriveData}T${hourArrive}`
          ).getTime();
        }
        const sortedReservations = dayReservations
          .splice(0, dayReservations.length)
          .sort((a, b) => Number(a.miliseconds) - Number(b.miliseconds));
        setReservations(sortedReservations);
        sortedDate.current = true;
      } else if (data === "leave") {
        const dayReservations = reservations.filter(
          (r) => r.leaveData === date
        );
        for (let i = 0; i < dayReservations.length; i++) {
          const hourLeave =
            dayReservations[i].leaveHour.length === 4
              ? `0${dayReservations[i].leaveHour}`
              : dayReservations[i].leaveHour;
          dayReservations[i].miliseconds = new Date(
            `${dayReservations[i].leaveData}T${hourLeave}`
          ).getTime();
        }
        const sortedReservations = dayReservations.sort(
          (a, b) => Number(a.miliseconds) - Number(b.miliseconds)
        );
        setReservations(sortedReservations);
        sortedDate.current = true;
      }
    } else {
      sortedDate.current = false;
      setReservations(searchReservations.current);
    }
  };

  useEffect(() => {
    const getAgents = async () => {
      const res = await axios.post(
        "https://rezerwacjaparkingu.com/backend_artlot/api/users/agents",
        {
          role: user.role,
        },
        {
          headers: { authorization: `megaparkingIGHERQHIGQRE ${token}` },
        }
      );
      setAgents(res.data);
    };
    getAgents();
  }, [user.role, token]);

  const sortByStatus = () => {
    if (!statusSorted.current) {
      const sortedStatus = reservations.filter((r) => r.hasArrived === false);
      statusSorted.current = true;
      setReservations(sortedStatus);
    } else {
      statusSorted.current = false;
      setReservations(searchReservations.current);
    }
  };
  const sortedByDestination = () => {
    if (!destinationCheck) {
      Swal.fire({
        title: "Sortuj rezerwację",
        html: `<input type="text" id="destination" class="swal2-input" placeholder="kierunek...">`,
        confirmButtonText: "Sortuj",
        confirmButtonColor: "#d0424e",
        cancelButtonText: "Anuluj",
        showCancelButton: true,
        focusConfirm: false,
        preConfirm: () => {
          const field = Swal.getPopup().querySelector("#destination").value;
          if (!field) {
            Swal.showValidationMessage(`Wypełnij powyższe pole`);
          }
          return { field: field };
        },
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("asd", result.value.field);
          let sortedReservations = searchReservations.current;
          sortedReservations = sortedReservations.filter((item) =>
            item.destination
              .toLowerCase()
              .includes(result.value.field.toLowerCase())
          );
          setReservations(sortedReservations);
          setDestinationCheck(true);
        }
      });
    } else {
      setReservations(searchReservations.current);
      setDestinationCheck(false);
    }
  };

  useEffect(() => {
    const getReservations = async () => {
      const role = user.role;
      if (role === "admin") {
        const res = await axios.get(
          `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/admin`,
          {
            headers: { authorization: "megaparkingIGHERQHIGQRE " + token },
          }
        );
        const sortedAll = res.data.filter((r) => r.isDone === true);
        searchAllReservations.current = sortedAll;
        setAllReservations(sortedAll);
      } else if (role === "agent") {
        const res = await axios.post(
          `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/agent`,
          { agent: user.login },
          {
            headers: { authorization: "megaparkingIGHERQHIGQRE " + token },
          }
        );
        searchAllReservations.current = res.data;
        setAllReservations(res.data);
      }
    };
    getReservations();
  }, [user?.agent, user?.role, user.login, token]);

  const reservationList = reservations.map((r) => (
    <Reservation reservation={r} key={r._id} />
  ));

  const allReservationList = allReservation.map((r) => (
    <Reservation reservation={r} historyP={true} key={r._id} />
  ));

  const agentsList = agents.map((a) => <Agent agent={a} key={a._id} />);

  let body;
  if (agentslist) {
    body = (
      <>
        <div className="agentListWrapper">
          <h3>LISTA AKTYWNYCH AGENTÓW</h3>
          <div className="list">{agentsList}</div>
        </div>
      </>
    );
  } else {
    body = (
      <div className="main">
        <div className="topbar">
          <div className="search">
            <Search className="icon" />
            <input
              type="text"
              placeholder="ZNAJDZ ZAMÓWIENIE"
              onChange={handleChangeReservations}
            />
          </div>
        </div>
        {historyP ? (
          <div className="date">
            <span style={{ fontSize: "40px" }}>HISTORIA</span>
          </div>
        ) : (
          <div className="date">
            <div className="dateDiv">
              <ArrowLeft className="icon" onClick={handleDataLeft} />
              <span className="notActive">{yestardayDate}</span>
              <span className="active">{date}</span>
              <span className="notActive">{tomarrowDate}</span>
              <ArrowRight className="icon" onClick={handleDataRight} />
            </div>
            {user.role === "admin" ? (
              <>
                <div className="countOfTakenDiv">
                  <span className="countOfTakenParking">
                    {countReservationsArrived}/{countReservations}
                  </span>
                </div>
              </>
            ) : null}
          </div>
        )}
        <div className="dataTable">
          <div className="wrapper">
            <div className="dataNames">
              <ul>
                <li>
                  <span>Dane personalne</span>
                </li>
                <li>
                  <span>Dane kontaktowe</span>
                </li>
                <li>
                  <span>Kierunek</span>
                  {!historyP ? (
                    <ArrowDropDown
                      className="icon"
                      onClick={sortedByDestination}
                    />
                  ) : null}
                </li>
                <li>
                  <span>Faktura</span>
                </li>
                <li>
                  <span>Data</span>
                  {!historyP ? (
                    <ArrowDropDown className="icon" onClick={sortByDate} />
                  ) : null}
                </li>
                <li>
                  <span>Statusy</span>{" "}
                  {!historyP ? (
                    <ArrowDropDown className="icon" onClick={sortByStatus} />
                  ) : null}
                </li>
              </ul>
            </div>
            <hr />
            <div className="dataRow">
              <div className="sorted">
                <span className="sortMobile">
                  Data <ArrowDropDown className="icon" onClick={sortByDate} />
                </span>
                <span className="sortMobile">
                  Status{" "}
                  <ArrowDropDown className="icon" onClick={sortByStatus} />
                </span>
              </div>
              {historyP ? allReservationList : reservationList}
            </div>
          </div>
        </div>
      </div>
    );
  }
  return body;
};

export default Main;
